<div class="cards-container">
    <ng-container *ngFor="let email of emails; let emailIndex = index">
        <div class="animated-col email-card ccc">
            <i class="app-icon icon icon-envelope icon-xxxl2"></i>
            
            <div class="card-item card-title fw-bold fs-4 py-3 my-4 cursor-pointer" (click)="viewDetails(email.emailId)">
                <div HJSuppress class="text-ellipsis" textEllipsisToTooltip ngbTooltip="">
                    {{email.emailAddress}}
                </div>
            </div>

            <div class="d-flex align-items-center gap-3">
                <button class="flex-grow-1 btn link-btn p-2" (click)="viewDetails(email.emailId)">
                    <i class="app-icon icon icon-edit icon-xl me-2"></i> 
                    {{'common.edit' | translate}}
                </button>
                <div class="divider align-self-stretch"></div>
                <button class="flex-grow-1 btn link-btn custom-delete-btn p-2" (click)="deleteEmail(email.emailId)">
                    <i class="app-icon icon icon-delete icon-xl me-2"></i> 
                    {{'common.delete' | translate | titlecase}}
                </button>
            </div>
        </div>
    </ng-container>
</div>
